module.exports = __webpack_public_path__ + "static/media/order_icon21.ab517223.png";